import { ScammersFetchData } from "../models/scammers-library.model";
import { axiosService } from "./axios.service";

export class ScammersLibraryService {
  static async getFilteredScammersLibrary(
    filter: string = "",
    page: number,
    limit: number
  ): Promise<ScammersFetchData | undefined> {
    try {
      return await axiosService.get(
        `/brand-reviews/scam-filter/${page}/${limit}/${filter}`
      );
    } catch (error) {
      console.error(error);
    }
  }
}
